export interface GeneratedStory {
  story: string;
  parentTip: string;
  discussionQuestions: string[];
}

export function generateMockStory(name: string, gender: "he" | "she" | "" = ""): GeneratedStory {
  const pronounVerb = gender === "she" ? "лежала" : "лежал";
  const pronounPast = gender === "she" ? "подумала" : "подумал";
  const pronounSmile = gender === "she" ? "улыбнулась" : "улыбнулся";
  const pronounSleep = gender === "she" ? "заснула" : "заснул";
  return {
    story: `Однажды за окном тихо падал мягкий снег.

В комнате горел тёплый ночник.

${name} ${pronounVerb} в своей кроватке и смотрел на потолок.

На потолке танцевали тени от ночника. Они были похожи на маленьких зверей, которые кружились в медленном танце.

«Интересно, — ${pronounPast} ${name}, — а куда они уходят, когда я засыпаю?»

И вдруг одна тень — маленький лисёнок — спрыгнула с потолка прямо на одеяло.

Лисёнок был мягкий и тёплый, как плюшевая игрушка. Только он умел разговаривать.

«Привет, ${name}! — прошептал лисёнок. — Меня зовут Огонёк.

Я прихожу каждую ночь, чтобы охранять твои сны.

Хочешь, я покажу тебе, куда уходят тени?»

${name} кивнул. Огонёк взял его за руку.

Они шагнули прямо в стену — и оказались в волшебном лесу.

Деревья здесь были сделаны из мягкого света. А вместо листьев на ветках висели маленькие звёзды.

«Это Лес Спокойных Снов, — объяснил Огонёк. — Здесь живут все добрые сны.

Видишь ту поляну?»

На поляне сидели другие тени-зверята. Они пели тихую песенку и плели из звёздного света одеяло.

Самое тёплое и уютное одеяло в мире.

«Это одеяло для тебя, — сказал Огонёк. — Каждую ночь мы делаем новое.

Поэтому тебе всегда тепло и безопасно, когда ты спишь.»

${name} ${pronounSmile}.

Зверята накинули на него звёздное одеяло. Оно было таким мягким, таким тёплым, что глаза сами начали закрываться.

«Спокойной ночи, ${name}, — прошептал Огонёк. — Я буду рядом. Всегда.»

И ${name} ${pronounSleep}.

Спокойно. Тепло. Безопасно.

А на потолке тихо кружились тени, охраняя его сон.`,

    parentTip: `Эта история помогает ребёнку почувствовать, что ночь — безопасное время, а темнота не несёт угрозы. Образ лисёнка-защитника создаёт внутреннюю опору: кто-то добрый всегда рядом. Не нужно обсуждать страхи напрямую — достаточно просто побыть вместе в этом тёплом ощущении после прочтения.`,

    discussionQuestions: [
      `Как ты думаешь, какой Огонёк на ощупь?`,
      `Тебе было бы спокойно в Лесу Снов?`,
      `А у тебя есть кто-то, кто помогает тебе чувствовать себя безопасно?`,
    ],
  };
}
